export const SELECT_TYPE = "SELECT_TYPE";
export const SELECT_SIZE = "SELECT_SIZE";
export const SELECT_COLOUR = "SELECT_COLOUR";
export const SELECT_QUANTITY = "SELECT_QUANTITY";

export function setType(shirt_type) {
    return {
        type: SELECT_TYPE,
        shirt_type
    }
}

export function setSize(size) {
    return {
        type: SELECT_SIZE,
        size
    }
}

export function setColour(colour) {
    return {
        type: SELECT_COLOUR,
        colour
    }
}

export function setQuantity(quantity) {
    return {
        type: SELECT_QUANTITY,
        quantity
    }
}